import { safRegistryPiletCapabilities } from '@sharefiledev/safregistry-pilet-sdk';
import type { PiletApi } from '@sharefiledev/sharefile-appshell';
import { aiAgentConfigCapabilities } from './capabilities';
import AsyncAiAgentConfigsViewList from './components/configs/AiAgentConfigsView';
import { addDevelopment } from './development';
import { configureSafRegistrySdk } from './http';
import { setLogger } from './logger';
import { extensionSlots } from './types';

export function setup(piletApi: PiletApi) {
	setLogger(piletApi.sf.getLogger());

	configureSafRegistrySdk(piletApi);
	piletApi.registerExtension(extensionSlots.aiAgentConfigsExtension, props => (
		<AsyncAiAgentConfigsViewList {...props} />
	));

	piletApi.sf.registerCapability(
		safRegistryPiletCapabilities.aiAgentConfigCapabilities,
		aiAgentConfigCapabilities
	);

	if (process.env.NODE_ENV === 'development') {
		addDevelopment(piletApi);
	}
}
